import React, { useState } from 'react';
import { useHeaderQuery } from '@querys/useHeaderQuery';
import cx from 'classnames';
import Headroom from 'react-headroom';
import SwitchLink from '@components/links/switchLink';
import { SanityImage } from '@components/sanity/sanityImage';
import BurgerMenu from './burgerMenu';
import { NavModal } from './navModal';
import { Link } from 'gatsby';
import { NavPopup } from './navPopup';
import { AnimatePresence } from 'framer-motion';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import LottiePlayer from '@components/media/lottiePlayer';

import Search from '@svg/search.svg';
import Phone from '@svg/phone.svg';
import GreenSearch from '@svg/greensearch.svg';
import GreenPhone from '@svg/greenphone.svg';

export const Header = ({ reverseHeader, unPinHeader, isHome }) => {
  const { mainMenu, serviceMenu, logo, reversedLogo, animatedLogo } =
    useHeaderQuery();
  const [isPinned, setPinned] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const [subNavOpen, setSubNavOpen] = useState(false);

  const toggleNav = () => setNavOpen((prev) => !prev);
  const toggleSubNav = () => setSubNavOpen((prev) => !prev);

  const aboutIndex = mainMenu?.findIndex(
    (l) => l?.mainLink?.linkText === 'About',
  );
  const filteredMenu = mainMenu?.filter(
    (l) => l?.mainLink?.linkText !== 'About',
  );

  const breakpoints = useBreakpoint();

  return (
    <React.Fragment>
      <Headroom
        style={{ zIndex: '6000' }}
        onPin={() => setPinned(true)}
        onUnpin={() => setPinned(false)}
        onUnfix={() => setPinned(false)}
        disable={unPinHeader}>
        <div
          className={cx('flex flex-col  ', {
            'bg-green-tint text-blue': isPinned || reverseHeader,
            'text-white': !isPinned && !reverseHeader,
          })}>
          <div
            className={cx(
              'hidden backdrop-blur-xs  xl:flex justify-end py-2  ',
              {
                ' bg-black/5': isPinned || reverseHeader,
                ' bg-white/10': !isPinned && !reverseHeader,
              },
            )}>
            <div className=' space-x-10 flex  px-10 blockH9 items-center '>
              <p
                onClick={toggleSubNav}
                className='cursor-pointer hover:opacity-50 transition-all duration-500 ease-in-out whitespace-nowrap'>
                {mainMenu[aboutIndex]?.mainLink?.linkText}
              </p>
              {filteredMenu?.map((item, i) => (
                <SwitchLink
                  className='hover:opacity-50 transition-all duration-500 ease-in-out whitespace-nowrap'
                  {...item?.mainLink}
                  key={i}
                />
              ))}
              <div className='flex space-x-4'>
                <a
                  href='tel:0800772077'
                  className='hover:bg-green/25 rounded-full transition-all ease-in-out duration-700'>
                  {isPinned || reverseHeader ? (
                    <GreenPhone className='w-9 h-9' />
                  ) : (
                    <Phone className='w-9 h-9' />
                  )}
                </a>
                {/* <p className="blockH9 self-center text-green font-medium">
                  0800 772 077
                </p> */}

                <Link
                  className='hover:bg-green/25 rounded-full transition-all ease-in-out duration-700'
                  to='/search'>
                  {isPinned || reverseHeader ? (
                    <GreenSearch className='w-9 h-9' />
                  ) : (
                    <Search className='w-9 h-9' />
                  )}
                </Link>
              </div>
            </div>
          </div>

          <div className='flex  w-full h-full justify-between items-center px-gutter  md:px-10 py-7 mt-2 xl:mt-0'>
            {!isHome && (
              <Link to='/'>
                <div className='max-w-[240px] sm:max-w-[276px] xl:max-w-[300px] 2xl:max-w-[360px] h-auto  pr-10 '>
                  <SanityImage
                    image={
                      isPinned || navOpen || reverseHeader ? reversedLogo : logo
                    }
                  />
                </div>
              </Link>
            )}
            {isHome && (
              <Link to='/'>
                <div className='max-w-[208px] sm:max-w-[276px] xl:max-w-[300px] 2xl:max-w-[360px] h-auto xl:pr-10   '>
                  {!isPinned && !navOpen ? (
                    <LottiePlayer
                      url={animatedLogo?.asset?.url}
                      playing={true}
                      autoplay={false}
                      className=' '
                    />
                  ) : (
                    <SanityImage
                      image={
                        isPinned || navOpen || reverseHeader
                          ? reversedLogo
                          : logo
                      }
                    />
                  )}
                </div>
              </Link>
            )}

            <div className='hidden xl:flex justify-between items-center gap-x-8 font-medium  '>
              {serviceMenu?.map((item, i) => (
                <SwitchLink
                  className='hover:opacity-50 transition-all duration-500 ease-in-out whitespace-nowrap'
                  {...item}
                  key={i}
                />
              ))}
            </div>
            {/* Burger Menu */}
            <div className=' xl:hidden justify-self-start self-center   z-50 '>
              <BurgerMenu
                navOpen={navOpen}
                toggleNav={toggleNav}
                // setSubNavOpen={setSubNavOpen}
                reverseHeader={reverseHeader}
                isPinned={isPinned}
                // setNonActiveTab={setNonActiveTab}
              />
            </div>
            <AnimatePresence exitBeforeEnter>
              {subNavOpen && breakpoints.xl && (
                <NavPopup
                  aboutMenu={mainMenu[aboutIndex]?.subLinks}
                  subNavOpen={subNavOpen}
                  setSubNavOpen={setSubNavOpen}
                />
              )}
            </AnimatePresence>
          </div>
        </div>
      </Headroom>

      <NavModal
        navOpen={navOpen}
        setNavOpen={setNavOpen}
        serviceMenu={serviceMenu}
        mainMenu={mainMenu}
      />
    </React.Fragment>
  );
};
